module.exports = __webpack_public_path__ + "static/img/solutionText31.858f1b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionText31.png
// module id = aFhY
// module chunks = 1